import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import Slider from 'react-slick';

import * as cartActionCreators from '../../../actions/cart';
let allActionCreators = Object.assign({}, cartActionCreators);

import RhinoSelect from '../../common/inputs/RhinoSelect';

class DiamondNecklaces extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {

      input1Metal: '',
      input1Length: '',
      input1Carat: '',

      error1Metal: '',
      error1Length: '',
      error1Carat: '',

      loadingButton: null,

      imageIndex1: 0,

      imgWrapHeight1: 0,
    }

    this.imgWrapper1 = null;

    this.imageList1 = [
      'flat.png',
      'lifestyle.png',
    ];

    this.metalTypeOptions = [
      {
        display: 'Select Metal Color',
        value: '',
      },
      {
        display: '14K White Gold',
        value: 'WG',
      },
      {
        display: '14K Yellow Gold',
        value: 'YG',
      },
    ];

    this.lengthOptions = [
      {
        display: 'Select Necklace Length',
        value: '',
      },
      {
        display: '16 inch',
        value: '16',
      },
      {
        display: '18 inch',
        value: '18',
      },
    ];

    this.caratOptions = [
      {
        display: 'Select Carat Weight',
        value: '',
      },
      {
        display: '3.00 ctw',
        value: 3,
      },
      {
        display: '5.00 ctw',
        value: 5,
      },
      {
        display: '7.00 ctw',
        value: 7,
      },
      {
        display: '9.00 ctw',
        value: 9,
      },
    ];

    this.info1 = {
      YG16: [
        {
          caratWeight: 3,
          image: 'NFANC33744.jpg', 
          sku: 'NFANC33744', 
          price: 5750, 
        },
        {
          caratWeight: 5,
          image: 'NFANC33605.jpg', 
          sku: 'NFANC33605', 
          price: 7920, 
        },
        {
          caratWeight: 7,
          image: 'NFANC33753.jpg', 
          sku: 'NFANC33753', 
          price: 9600, 
        },
        {
          caratWeight: 9,
          image: 'NFANC33750.jpg', 
          sku: 'NFANC33750', 
          price: 12600, 
        },
      ],
      YG18: [
        {
          caratWeight: 3,
          image: 'NFANC33599.jpg', 
          sku: 'NFANC33599', 
          price: 5750, 
        },
        {
          caratWeight: 5,
          image: 'NFANC33591.jpg', 
          sku: 'NFANC33591', 
          price: 7920, 
        },
        {
          caratWeight: 7,
          image: 'NFANC33598.jpg', 
          sku: 'NFANC33598', 
          price: 9600, 
        },
        {
          caratWeight: 9,
          image: 'NFANC33594.jpg', 
          sku: 'NFANC33594', 
          price: 12600, 
        },
      ],
      WG16: [
        {
          caratWeight: 3,
          image: 'NFANC33585.jpg', 
          sku: 'NFANC33585', 
          price: 5750, 
        },
        {
          caratWeight: 5,
          image: 'NFANC33588.jpg', 
          sku: 'NFANC33588', 
          price: 7920, 
        },
        {
          caratWeight: 7,
          image: 'NFANC33579.jpg', 
          sku: 'NFANC33579', 
          price: 9600, 
        },
        {
          caratWeight: 9,
          image: 'NFANC33756.jpg', 
          sku: 'NFANC33756', 
          price: 12600, 
        },
      ],
      WG18: [
        {
          caratWeight: 3,
          image: 'NFANC32237.jpg', 
          sku: 'NFANC32237', 
          price: 5750, 
        },
        {
          caratWeight: 5,
          image: 'NFANC29560.jpg', 
          sku: 'NFANC29560', 
          price: 7920, 
        },
        {
          caratWeight: 7,
          image: 'NFANC32240.jpg', 
          sku: 'NFANC32240', 
          price: 9600, 
        },
        {
          caratWeight: 9,
          image: 'NFANC29565.jpg', 
          sku: 'NFANC29565', 
          price: 12600, 
        },
      ],
    };

    this.imgWrapRef = null;

    this.checkHeight = ::this.checkHeight;
	}

	componentDidMount() {
    document.title = 'Diamonds Direct';
    window.addEventListener('resize', this.checkHeight, false);
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";

    this.checkHeight();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkHeight, false);
  }

  checkHeight() {
    if(this.imgWrapRef) {
      try {
        if(this.imgWrapRef.getBoundingClientRect().height != this.state.imgWrapHeight1 && this.state.imgWrapHeight1 > 200) {
          this.setState({ imgWrapHeight1: this.imgWrapRef.getBoundingClientRect().height });
        }
      } catch(err) {
        console.error(err);
      }
    }
  }

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  openIntercom() {
    acquireIO.max();
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  changeMetal(evt, idx) {
    this.setState({ 
      input1Metal: evt.target.value, 
    }, () => {
      if(this.state.error1Metal) {
        this.setState({ error1Metal: '' });
      }
      if(this.state.input1Metal && this.state.input1Length && this.state.input1Carat) {
        this.setState({ imageIndex1: 2 });
      }
    });
  }

  changeLength(evt, idx) {
    this.setState({ 
      input1Length: evt.target.value, 
    }, () => {
      if(this.state.error1Length) {
        this.setState({ error1Length: '' });
      }
      if(this.state.input1Metal && this.state.input1Length && this.state.input1Carat) {
        this.setState({ imageIndex1: 2 });
      }
    });
  }

  changeCarat(evt, idx) {
    this.setState({ 
      input1Carat: evt.target.value, 
    }, () => {
      if(this.state.error1Carat) {
        this.setState({ error1Carat: '' });
      }
      if(this.state.input1Metal && this.state.input1Length && this.state.input1Carat) {
        this.setState({ imageIndex1: 2 });
      }
    });
  }

  defaultImg() {
    return <img src={`https://ddw2.diamondsdirect.com/img/diamondpages/necklaces/${this.imageList1[0]}`} />;
  }

  getNecklace1Img() {

    const heightStyle = this.state.imgWrapHeight1 ? { height: `${this.state.imgWrapHeight1}px` } : {};

    if(this.state.imageIndex1 === 2) {
      if(this.state.input1Metal && this.state.input1Length && this.state.input1Carat) {
        const nObj = this.getNecklaceObj();
        if(nObj.image) {
          return <img src={`https://ddw2.diamondsdirect.com/img/diamondpages/necklaces/${nObj.image}`} style={heightStyle} />;
        }
      } else {
        return this.defaultImg();
      }
    } else {
      return <img src={`https://ddw2.diamondsdirect.com/img/diamondpages/necklaces/${this.imageList1[this.state.imageIndex1]}`} style={heightStyle} />;
    }
    
    return this.defaultImg();
  }

  getBraceletDesc(caratWeight, addSku = null) {

    let diaDesc = '';

    if(addSku) {
      diaDesc += ('<B>SKU</B>: ' + addSku + '<br />');
    }
    if(caratWeight) {
      diaDesc += ('<B>Carat Weight</B>: ' + parseFloat(caratWeight).toFixed(2) + ' (NOTE: The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%)<br />');
    }
    diaDesc += `<B>Metal type</B>: 14 karat ${this.state.input1Metal == 'YG' ? 'yellow' : 'white'} gold<br /><B>Chain Length</B>: ${parseFloat(this.state.input1Length).toFixed(1)} in<br /><B>Color</B>: The average color range for necklaces is I - J<br /><B>Clarity</B>: The average clarity range for necklaces is SI`;
    return diaDesc;
  }

  addToCart(sku, caratPrice, code) {

    if(!this.state.input1Carat) {
      this.setState({ error1Carat: 'Please select a carat weight' });
    }

    if(!this.state.input1Length) {
      this.setState({ error1Length: 'Please select a length' });
    }

    if(!this.state.input1Metal) {
      this.setState({ error1Metal: 'Please select a metal type' });
    }

    const necklaceObj = this.getNecklaceObj();
    if(!necklaceObj) {
      return null;
    }

    // {
    //       caratWeight: 5,
    //       image: 'NFANC33591.jpg', 
    //       sku: 'NFANC33591', 
    //       price: 7920, 
    //     },

    this.setState({ loadingButton: code });

    // this.props.cartGuestAddItem(sku, this.getBraceletDesc(necklaceObj.caratWeight, necklaceObj.sku), necklaceObj.price)
    // .then((resp) => {
    //   this.externalNav('checkout/cart');
    // })
    // .catch((errResp) => {
    //   this.setState({ loadingButton: null });
    // });

    this.props.cartAddDiamondJewelry(necklaceObj.sku, necklaceObj.price, this.getBraceletDesc(necklaceObj.caratWeight, necklaceObj.sku))
    .then((resp) => {
      this.externalNav('checkout/cart');
    })
    .catch((errResp) => {
      this.setState({ loadingButton: null });
    });
  }

  getNecklaceObj() {

    if(!this.state.input1Metal || !this.state.input1Length || !this.state.input1Carat) {
      return null;
    }

    const dataRef = this.info1;
    const idx = `${this.state.input1Metal}${this.state.input1Length}`;

    if(!dataRef[idx]) { return null; }

    for(const no of dataRef[idx]) {
      if(parseInt(this.state.input1Carat) && parseInt(this.state.input1Carat) == no.caratWeight) {
        return no;
      }
    }

    return null;
  }

  defaultPrice() {
    if(!this.state.input1Carat) {
      return this.info1['YG16'][0].price;
    }

    for(const no of this.info1['YG16']) {
      if(parseInt(this.state.input1Carat) && parseInt(this.state.input1Carat) == parseInt(no.caratWeight)) {
        return no.price;
      }
    }

    return this.info1['YG16'][0].price;
  }

  getNecklace1Price() {
    if(!this.state.input1Metal || !this.state.input1Length || !this.state.input1Carat) {
      return this.defaultPrice();
    }

    const nObj = this.getNecklaceObj();
    if(nObj.price) {
      return nObj.price;
    }

    return this.defaultPrice();
  }

  rotateImage() {
    const imgLength = this.state.input1Metal && this.state.input1Length && this.state.input1Carat ? 3 : 2;
    const newIdx = this.state.imageIndex1 === imgLength - 1 ? 0 : this.state.imageIndex1 + 1;
    this.setState({
      imageIndex1: newIdx,
    });
  }

  render() {
    return <div className='DiamondNecklaces DiamondPage'>

      <div className='dPagePreload'>
        {this.imageList1.map((img, k) => {
          return <img src={`https://ddw2.diamondsdirect.com/img/diamondpages/necklaces/${img}`} />
        })}
      </div>
      <div className='dpBreadcrumbs'>Diamond Necklaces</div>
      <div className='dpProductsWrapper'>
        <div className='dpProduct single'>
          <div className='dpItemWrapper'>
            <div className={'dpProductImg necklaceImg'} ref={(div) => { this.imgWrapRef = div; }}>
              {this.getNecklace1Img()}
              <div className='imageToggle' onClick={() => this.rotateImage()} style={{ display: 'block' }}>
                <i className="fas fa-exchange-alt"></i>
              </div>
            </div>
            <div className='dpProductTitle'>Tennis Necklace</div>
            <div className='dpProductConfigElement inline'>
              <RhinoSelect
                options={this.metalTypeOptions}
                value={this.state.input1Metal}
                changeMethod={(evt) => this.changeMetal(evt, 1)}
                rootClass='productSelect' />
              {this.state.error1Metal ?
                <div className='dpErrorMessage'>{this.state.error1Metal}</div> :
                null
              }
            </div>
            <div className='dpProductConfigElement inline middle'>
              <RhinoSelect
                options={this.lengthOptions}
                value={this.state.input1Length}
                changeMethod={(evt) => this.changeLength(evt, 1)}
                rootClass='productSelect' />
              {this.state.error1Length ?
                <div className='dpErrorMessage'>{this.state.error1Length}</div> :
                null
              }
            </div>
            <div className='dpProductConfigElement inline'>
              <RhinoSelect
                options={this.caratOptions}
                value={this.state.input1Carat}
                changeMethod={(evt) => this.changeCarat(evt, 1)}
                rootClass='productSelect' />
              {this.state.error1Carat ?
                <div className='dpErrorMessage'>{this.state.error1Carat}</div> :
                null
              }
            </div>
            <div className='dpBr'></div>
            <div className='dpPrice'>${this.getNecklace1Price().toLocaleString()}</div>
            {this.state.loadingButton == 'carat1' ?
              <div className='dpAddToCart dpLoading'><div><i className="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;&nbsp;Adding to Cart</div></div> :
              <div className='dpAddToCart' onClick={() => this.addToCart('DIATENNECK', this.state.carat1 ? this.state.carat1 : this.state.price1, 'carat1')}><div>Add to Cart</div></div>
            }
          </div>
        </div>

      </div>
    </div>;
	}
}
export default DiamondNecklaces;

function mapStateToProps(state) {
  return {

  };
}

export const DiamondNecklacesContainer = connect(
  mapStateToProps,
  allActionCreators
)(DiamondNecklaces);


// WEBPACK FOOTER //
// ./src/components/views/diamondpages/DiamondNecklaces.jsx